import { useAuth0 } from "@auth0/auth0-react";
import FeedsSkelton from "components/Skelton/PastoralSkelton/FeedsSkelton";
import { formatDate } from "helper/dateFormat";
import PastoralService from "Lib/API/PastoralApi/index";
import React, { useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { toastr } from "react-redux-toastr";
import Loader from "../../../components/loader/Loader";
import FeedCard from "./FeedCard.js";
import FeedsHeader from "./FeedsHeader.js";
const limitedColors = ["orange", "#FA3372", "#2555EF"];

const Feeds = ({
  openMemberEventDrawer,
  callFeedsAgain,
  setCallFeedsAgain,
  openContactDrawerHandler,
}) => {
  const feedsRef = useRef(null);
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [feedCardData, setFeedCardData] = useState([]);
  const [totalFeeds, setTotalFeeds] = useState(false);
  const [page, setPage] = useState(1);

  React.useEffect(() => {
    if (feedsRef?.current) {
      feedsRef.current.scrollTop = 0;
    }
    setFeedCardData([]);
    setPage(1);
    fetchMyAPI(1);
  }, [callFeedsAgain]);

  const fetchMyAPI = async (initialPage) => {
    setLoading(true);
    const currentPage = initialPage || page;
    const token = await getAccessTokenSilently();
    PastoralService.getPastoralFeeds({ token, page: currentPage, limit: 30 })
      .then((res) => {
        if (res) {
          let newFeedList = currentPage === 1 ? [] : [...feedCardData];
          newFeedList.push(...res?.feed);
          setFeedCardData(newFeedList);
          setTotalFeeds(res?.hasMore);
          setPage((prevPage) => prevPage + 1);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      className="event-tasks w-100 events-feed"
      style={{ background: "rgba(243, 246, 249, 0.2)" }}
    >
      <FeedsHeader setCallFeedsAgain={setCallFeedsAgain} />
      <div className="p-2" style={{ background: "white" }}>
        <div className="">
          <div
            className="tasks-body tasks-scroll p-3"
            ref={feedsRef}
            id="feeds-wrapper"
          >
            <div>
              {feedCardData?.length === 0 && !loading && (
                <h3 className="text-center mt-5">No Data</h3>
              )}
              {loading && feedCardData?.length === 0 ? (
                <FeedsSkelton length={6} />
              ) : (
                <>
                  <InfiniteScroll
                    scrollableTarget="feeds-wrapper"
                    dataLength={feedCardData.length}
                    next={fetchMyAPI}
                    hasMore={totalFeeds}
                    loader={<FeedsSkelton length={1} />}
                  >
                    {feedCardData?.map((item, id) => {
                      return (
                        <FeedCard
                          key={item.id}
                          feedAvatar={item.avtar}
                          name={item.name}
                          firstName={item?.fname}
                          lastName={item.lname}
                          subtitle={item.subtitle ?? item.name}
                          description={item.description}
                          postTime={item.postTime}
                          color={
                            limitedColors[
                              Math.floor(Math.random() * limitedColors.length)
                            ]
                          }
                          background={item.background}
                          status={item.type}
                          date={formatDate({
                            date: item?.ShowDate,
                            formatType: "default",
                          })}
                          changedBy={item?.changed_by}
                          suggestionText={item?.memo}
                          onEventClick={() => openMemberEventDrawer(item)}
                          onContactClick={() => openContactDrawerHandler(item)}
                        />
                      );
                    })}
                  </InfiniteScroll>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feeds;
